import { render } from "./ModalShowExp.vue?vue&type=template&id=e36be688"
import script from "./ModalShowExp.vue?vue&type=script&lang=js"
export * from "./ModalShowExp.vue?vue&type=script&lang=js"

import "./ModalShowExp.vue?vue&type=style&index=0&id=e36be688&lang=css"

import exportComponent from "/Users/administrador/Documents/RepositoriosLMX/app-tent-register/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__